// Utility to build and print the "Senarai Penyewa" report
// Usage: await printPenyewaPreview(filters)

import { apiGetAkaunForPrint } from "api/akaun";

function buildPrintHtml({ data = [], filters = {}, currentUser = {} }) {
  // Sort by nama (customer.nama or nama) ascending
  const sortedData = [...data].sort((a, b) => {
    const aNama = (a.customer?.nama || a.nama || "").toString();
    const bNama = (b.customer?.nama || b.nama || "").toString();
    return aNama.localeCompare(bNama, undefined, { sensitivity: "base" });
  });

  const titleLines = [
    `LAPORAN SENARAI PENYEWA ${currentUser.bahagian ? currentUser.bahagian.toUpperCase() : ""}`,
  ];
  // Preserve existing header behavior: show Zon only if provided
  if (filters.zonharta) titleLines.push(`Zon: ${filters.zonharta}`);

  return `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="utf-8" />
        <title>Laporan Senarai Penyewa</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; font-size: 12px; }
          .header { text-align: center; margin-bottom: 20px; }
          .title { font-weight: bold; font-size: 14px; margin-bottom: 10px; }
          .logo-kejora { display: block; margin: 0 auto 8px auto; height: 48px; }
          table { width: 100%; border-collapse: collapse; border: 1px solid black; }
          th, td { border: 1px solid black; padding: 4px; text-align: left; font-size: 10px; }
          th { background-color: #f0f0f0; font-weight: bold; text-align: center; }
          .number { text-align: center; }
          .amount { text-align: right; }
          .footer { margin-top: 20px; display: flex; justify-content: space-between; font-size: 10px; }
          @media print { body { margin: 10px; } .no-print { display: none; } }
        </style>
      </head>
      <body>
        <div class="header">
          <img src="/build/kejora.png" alt="KEJORA" class="logo-kejora" />
          <div class="title">${titleLines.join("<br/>")}</div>
          <div>Tarikh: ${new Date().toLocaleDateString("ms-MY")}</div>
        </div>
        <table>
          <thead>
            <tr>
              <th style="width: 30px;">BIL</th>
              <th style="width: 80px; text-align:center;">NO. AKAUN</th>
              <th style="width: 200px;">NAMA</th>
              <th style="width: 100px;">NO KP</th>
              <th style="width: 70px; text-align:center;">KOD HARTA</th>
              <th style="width: 100px;">KADAR SEWA (RM)</th>
              <th style="width: 80px; text-align:center;">STATUS AKAUN</th>
            </tr>
          </thead>
          <tbody>
            ${sortedData
              .map(
                (row, index) => `
              <tr>
                <td class="number">${index + 1}</td>
                <td style="text-align:center;">${row.no_akaun || "-"}</td>
                <td>${row.nama || "-"}</td>
                <td>${row.no_kp || "-"}</td>
                <td style="text-align:center;">${row.kod_harta || "-"}</td>
                <td class="amount">${row.kadar_sewa ? Number(row.kadar_sewa).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00"}</td>
                <td style="text-align:center;">${row.status_akaun || "-"}</td>
              </tr>
            `
              )
              .join("")}
          </tbody>
        </table>
        <div class="footer">
          <div>Jumlah rekod: ${sortedData.length}</div>
          <div>Dicetak pada: ${new Date().toLocaleString("ms-MY")}</div>
        </div>
      </body>
    </html>
  `;
}

export async function printPenyewaPreview(filters = {}) {
  const response = await apiGetAkaunForPrint(filters);
  const data = response?.data || [];

  if (!data || data.length === 0) {
    alert("Tiada data untuk dicetak.");
    return false;
  }

  const win = window.open("", "_blank");
  if (!win) {
    alert("Gagal membuka tetingkap cetakan.");
    return false;
  }

  const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
  const html = buildPrintHtml({ data, filters, currentUser });

  win.document.write(html);
  win.document.close();

  setTimeout(() => {
    try {
      win.focus();
      win.print();
    } catch (_) {
      // no-op
    }
  }, 500);

  return true;
}

export default printPenyewaPreview;
